
import { useState, useEffect } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { X, Eye } from 'lucide-react';
import { getAnalyticsConsent, setAnalyticsConsent } from '@/utils/analytics';

const AnalyticsConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const hasConsent = localStorage.getItem('analytics_consent');
    if (hasConsent === null) {
      // Show banner after a short delay to not interfere with initial page load
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    setAnalyticsConsent(true);
    setShowBanner(false);
  };

  const handleDecline = () => {
    setAnalyticsConsent(false);
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 md:left-auto md:max-w-md">
      <Card className="shadow-lg border-purple-200">
        <CardContent className="p-4">
          <div className="flex items-start gap-3">
            <Eye className="h-5 w-5 text-purple-600 mt-0.5 flex-shrink-0" />
            <div className="flex-1">
              <h3 className="font-semibold text-sm mb-2">Help Us Improve</h3>
              <p className="text-sm text-gray-600 mb-3">
                We use session recording to understand how you use our app and improve your experience. 
                No sensitive data like passwords or payment info is recorded.
              </p>
              <div className="flex gap-2">
                <Button 
                  onClick={handleAccept}
                  size="sm" 
                  className="bg-purple-600 hover:bg-purple-700 text-xs"
                >
                  Allow
                </Button>
                <Button 
                  onClick={handleDecline}
                  variant="outline" 
                  size="sm"
                  className="text-xs"
                >
                  Decline
                </Button>
              </div>
            </div>
            <Button
              onClick={handleDecline}
              variant="ghost"
              size="sm"
              className="p-1 h-6 w-6 flex-shrink-0"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AnalyticsConsent;
